import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Customer} from "../../../../../shared/model/customer";
import {HttpCustomService} from "../../../../../service/http-custom.service";
import {
  checkUniqueCustomerCode,
  checkUniqueMeasuringPointCode
} from "../../../../../shared/validator/customer-validator";
import {checkUniqueMeterCode} from "../../../../../shared/validator/meter-validator";
import * as _ from "lodash";
import {MeterSampleSelect} from "../../../../../shared/constants/meter-sample.enum";
import {checkUniqueUserName} from "../../../../../shared/validator/user-validator";

@Component({
  selector: 'omni-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.scss']
})
export class CustomerFormComponent implements OnInit, OnChanges, AfterViewInit {
  formGroup: FormGroup;
  defaultValue = {};
  @Input() stationNo: number;
  @Input() stationName: string;
  @Input() customer: Customer;
  @Input() isEdit = false;
  meterSampleSelect = MeterSampleSelect;

  constructor(
    private fb: FormBuilder,
    private http: HttpCustomService
  ) { }

  ngOnInit(): void {
    if (!this.isEdit) {
      this.buildForm();
    }
  }
  buildForm(): void {
    this.formGroup = this.fb.group({
      stationNo: [this.stationNo, Validators.required],
      customerNo: [null],
      customerName: [null],
      customerCode: [null, Validators.required],
      meterCode: [null, Validators.required],
      meterSample: [null, Validators.required],
      measuringPointCode: [null, Validators.required],
      userName: [null, Validators.required],
      password: [null, Validators.required],
      userNo: [null],
    });
    this.formGroup.get('customerCode').setAsyncValidators(checkUniqueCustomerCode(this.http));
    this.formGroup.get('meterCode').setAsyncValidators(checkUniqueMeterCode(this.http));
    this.formGroup.get('userName').setAsyncValidators(checkUniqueUserName(this.http));
    this.formGroup.get('measuringPointCode').setAsyncValidators(checkUniqueMeasuringPointCode(this.http));
  }

  ngAfterViewInit(): void {
    this.defaultValue = this.formGroup.getRawValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customer && !_.isEqual(changes.customer.previousValue, changes.customer.currentValue) && !_.isEmpty(this.customer)) {
      this.stationNo = this.customer.stationNo;
      this.stationName = this.customer.stationName;
      if (_.isNil(this.formGroup)) {
        this.buildForm();
      }
      this.formGroup.patchValue({
        stationNo: this.customer.stationNo,
        customerNo: this.customer.customerNo,
        customerName: this.customer.customerName,
        customerCode: this.customer.customerCode,
        meterCode: this.customer.meterCode,
        meterSample: this.customer.meterSample,
        measuringPointCode: this.customer.measuringPointCode,
        userNo: this.customer.userNo,
        userName: this.customer.userName,
        password: this.customer.password || this.customer.rawPassword
      });
    }
  }

}
